import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useErrorHandling } from '@/utils/errorHandling';
import { WorkfeedSetupRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { TwoInputConnection } from '@/pages/company/common/TwoInputConnection';

interface WorkfeedConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const WorkfeedConnect = (props: WorkfeedConnectProps) => {
    const { t } = useTranslation();
    const [workfeedData, setWorkfeedData] = useState<WorkfeedSetupRequest>(
        {} as any
    );
    const { backendErrorHandler } = useErrorHandling();

    const { setupWorkfeed } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        setupWorkfeed.mutate({
            workfeedCompanyId: workfeedData?.workfeedCompanyId,
            apiKey: workfeedData?.apiKey
        });
    };

    useEffect(() => {
        if (setupWorkfeed.isSuccess) {
            props.onSaveSuccess();
        }
    }, [setupWorkfeed.isSuccess]);

    useEffect(() => {
        if (setupWorkfeed.isError) {
            // Surface the backend's reason (invalid key vs unknown company) rather
            // than a generic failure - it is the only hint the operator gets.
            backendErrorHandler(t('workfeed_connection_failed'))(
                setupWorkfeed.error as Error
            );
        }
    }, [setupWorkfeed.isError]);

    useEffect(() => {
        dispatch(setLoader(setupWorkfeed.isPending));
    }, [setupWorkfeed.isPending]);

    return (
        <>
            <TwoInputConnection
                input1Value={workfeedData?.workfeedCompanyId}
                input2Value={workfeedData?.apiKey}
                input1Label={t('workfeed_company_id')}
                input2Label={t('workfeed_api_key')}
                input1Placeholder={t('')}
                input2Placeholder={t('')}
                input1OnChange={(val: any) => {
                    setWorkfeedData({
                        ...workfeedData,
                        workfeedCompanyId: val.target.value
                    });
                }}
                input2OnChange={(val) => {
                    setWorkfeedData({
                        ...workfeedData,
                        apiKey: val.target.value
                    });
                }}
                primaryDisabled={
                    !workfeedData.workfeedCompanyId || !workfeedData?.apiKey
                }
                primaryButtonTitle={t('connect')}
                secondaryButtonTitle={t('cancel')}
                onClickPrimary={onClick}
                onClickSecondary={() => {
                    props.onClose?.();
                }}
            />
        </>
    );
};
